export default () => {
  let userAgent = navigator.userAgent; 
  let isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
  let isEdge = userAgent.indexOf("Edge") > -1 && !isIE;
  let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
  let isOpera = userAgent.indexOf("Opera") > -1;
  if (isOpera) {
    return "Opera"
  }; 
  if (userAgent.indexOf("Firefox") > -1) {
    return "FF";
  } 
  if (userAgent.indexOf("Chrome") > -1) {
    return "Chrome";
  }
  if (userAgent.indexOf("Safari") > -1) {
    return "Safari";
  } 
  if (isEdge){
    return "Edge";
  }
  if (isIE || isIE11) {
    return "IE";
  }
}


// WEBPACK FOOTER //
// ./src/static/js/utils/modules/browserType.js